import "esbuild-css-modules-plugin-ns-css:src/artifacts/shared/styles/holder/toast.module.css";

export default {
  "holder": "toast-module__holder_Qn2kBG__010"
};
      